import { wasHeaderModalVisible } from '../actions/AppHeaderModalActions';

const bookmarksState = (
  currentState = {
    isBookmarksVisible: wasHeaderModalVisible('SHOW_BOOKMARKS'),
    bookmarks: localStorage.getItem('netacad-Bookmarks')
      ? JSON.parse(localStorage.getItem('netacad-Bookmarks'))
      : { list: [], structure: {} }
  },
  action
) => {
  switch (action.type) {
    case 'SHOW_BOOKMARKS':
      return {
        ...currentState,
        isBookmarksVisible: true
      };
    case 'HIDE_BOOKMARKS':
      return {
        ...currentState,
        isBookmarksVisible: false
      };
    case 'UPDATE_BOOKMARKS':
      return {
        ...currentState,
        bookmarks: JSON.parse(localStorage.getItem('netacad-Bookmarks'))
      };
    case 'CLOSE_MODAL':
      return {
        ...currentState,
        isBookmarksVisible: false
      };
    default:
      return currentState;
  }
};
export default bookmarksState;
